import { Component, ViewEncapsulation } from '@angular/core';
import { ToastUtilService } from './services/toast-util.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'issqn';

  constructor(public toastUtilService: ToastUtilService) {}

  onClose(): void {
    this.toastUtilService.position = 'center';
  }
}
